export enum PARAM_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
};

